import React from 'react'
import Grid from "@material-ui/core/Grid";
import { useStyle } from './Style';

const RecentPaymentsHeader = (props) => {
  const classes = useStyle();
  return (
    <>
      <section className={classes.claimsheader}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.claimstitle}>
              <h1>{props.title}</h1>
              <div className={classes.subtitle}>
                <p>View all payments from the past 30 days</p>
              </div>
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  )
}

export default RecentPaymentsHeader